import { createElement } from "react";
import { twMerge } from "tailwind-merge";

const iconDefs = {
  home: () => (
    <svg className="w-full h-full" viewBox="0 0 24 26" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="Home">
        <path
          id="Vector"
          d="M8.30198 23.4907V19.6647C8.30198 18.688 9.09954 17.8962 10.0834 17.8962H13.6798C14.1522 17.8962 14.6053 18.0825 14.9394 18.4142C15.2735 18.7458 15.4612 19.1956 15.4612 19.6647V23.4907C15.4582 23.8968 15.6186 24.2872 15.9068 24.5754C16.1949 24.8636 16.5871 25.0256 16.9961 25.0256H19.4497C20.5956 25.0286 21.6957 24.5787 22.507 23.7754C23.3184 22.972 23.7744 21.8811 23.7744 20.7435V9.84366C23.7744 8.92472 23.364 8.05305 22.654 7.46348L14.3072 0.845703C12.8552 -0.31462 10.7749 -0.277156 9.36634 0.934681L1.21 7.46348C0.466404 8.03567 0.0219629 8.90992 0 9.84366V20.7324C0 23.1035 1.93621 25.0256 4.32465 25.0256H6.72225C7.57179 25.0256 8.26221 24.3452 8.26837 23.5019L8.30198 23.4907Z"
        />
      </g>
    </svg>
  ),
  homeOutline: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-Ffull"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
      />
    </svg>
  ),
  waving: () => (
    <svg className="w-full h-full" viewBox="0 0 21 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector"
        d="M10.2439 0C11.6524 0 12.8049 1.125 12.8049 2.5C12.8049 3.875 11.6524 5 10.2439 5C8.83537 5 7.68293 3.875 7.68293 2.5C7.68293 1.125 8.83537 0 10.2439 0ZM15.2378 7.625C14.7256 7.125 13.8293 6.25 12.1646 6.25H8.96341C5.37805 6.25 2.56098 3.5 2.56098 0H0C0 4 2.68902 7.25 6.40244 8.375V25H8.96341V17.5H11.5244V25H14.0854V10.125L19.2073 15L21 13.25L15.2378 7.625Z"
      />
    </svg>
  ),
  patient: () => (
    <svg className="w-full h-full" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="fluent:patient-20-filled">
        <path
          id="Vector"
          d="M16.0002 6.40001C15.178 6.40001 14.3895 6.73715 13.8082 7.33727C13.2268 7.93739 12.9002 8.75132 12.9002 9.60001C12.9002 10.4487 13.2268 11.2626 13.8082 11.8628C14.3895 12.4629 15.178 12.8 16.0002 12.8C16.8224 12.8 17.6109 12.4629 18.1922 11.8628C18.7736 11.2626 19.1002 10.4487 19.1002 9.60001C19.1002 8.75132 18.7736 7.93739 18.1922 7.33727C17.6109 6.73715 16.8224 6.40001 16.0002 6.40001ZM10.5752 23.2C10.3697 23.2 10.1725 23.2843 10.0272 23.4343C9.88185 23.5844 9.8002 23.7878 9.8002 24C9.8002 24.2122 9.88185 24.4157 10.0272 24.5657C10.1725 24.7157 10.3697 24.8 10.5752 24.8H21.4252C21.6307 24.8 21.8279 24.7157 21.9732 24.5657C22.1185 24.4157 22.2002 24.2122 22.2002 24C22.2002 23.7878 22.1185 23.5844 21.9732 23.4343C21.8279 23.2843 21.6307 23.2 21.4252 23.2H10.5752ZM6.7002 6.40001C6.7002 5.55132 7.0268 4.73739 7.60816 4.13727C8.18953 3.53715 8.97802 3.20001 9.8002 3.20001H22.2002C23.0224 3.20001 23.8109 3.53715 24.3922 4.13727C24.9736 4.73739 25.3002 5.55132 25.3002 6.40001V25.6C25.3002 26.4487 24.9736 27.2626 24.3922 27.8628C23.8109 28.4629 23.0224 28.8 22.2002 28.8H9.8002C8.97802 28.8 8.18953 28.4629 7.60816 27.8628C7.0268 27.2626 6.7002 26.4487 6.7002 25.6V6.40001ZM22.2002 4.80001H9.8002C9.38911 4.80001 8.99486 4.96858 8.70418 5.26864C8.4135 5.5687 8.2502 5.97567 8.2502 6.40001V19.2H11.3502V16C11.3502 15.5757 11.5135 15.1687 11.8042 14.8686C12.0949 14.5686 12.4891 14.4 12.9002 14.4H19.1002C19.5113 14.4 19.9055 14.5686 20.1962 14.8686C20.4869 15.1687 20.6502 15.5757 20.6502 16V19.2H23.7502V6.40001C23.7502 5.97567 23.5869 5.5687 23.2962 5.26864C23.0055 4.96858 22.6113 4.80001 22.2002 4.80001ZM8.2502 20.8V25.6C8.2502 26.0244 8.4135 26.4313 8.70418 26.7314C8.99486 27.0314 9.38911 27.2 9.8002 27.2H22.2002C22.6113 27.2 23.0055 27.0314 23.2962 26.7314C23.5869 26.4313 23.7502 26.0244 23.7502 25.6V20.8H8.2502Z"
        />
      </g>
    </svg>
  ),
  stats: () => (
    <svg className="w-full h-full" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="ic:baseline-assessment">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
        />
      </g>
    </svg>
  ),
  presentation: () => (
    <svg className="w-full h-full" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="ri:presentation-fill">
        <path
          id="Vector"
          d="M8 4C8 4.53043 7.78929 5.03914 7.41421 5.41421C7.03914 5.78929 6.53043 6 6 6C5.46957 6 4.96086 5.78929 4.58579 5.41421C4.21071 5.03914 4 4.53043 4 4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2C6.53043 2 7.03914 2.21071 7.41421 2.58579C7.78929 2.96086 8 3.46957 8 4ZM5 16V22H3V10C2.99991 9.40845 3.1747 8.83008 3.5024 8.3376C3.8301 7.84512 4.29609 7.46051 4.84177 7.23213C5.38745 7.00375 5.98847 6.94179 6.56927 7.05404C7.15006 7.16629 7.68471 7.44773 8.106 7.863L10.48 10.106L12.793 7.793L14.207 9.207L10.52 12.894L9 11.46V22H7V16H5ZM10 5H19V14H10V16H14.365L17.189 22H19.399L16.576 16H20C20.2652 16 20.5196 15.8946 20.7071 15.7071C20.8946 15.5196 21 15.2652 21 15V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3H10V5Z"
        />
      </g>
    </svg>
  ),
  squares: () => (
    <svg className="w-full h-full" viewBox="0 0 26 26" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="Iconly/Bold/Category">
        <g id="Category">
          <path
            id="Vector"
            d="M7.40759 14.3518C9.1719 14.3518 10.5858 15.7795 10.5858 17.5564V21.822C10.5858 23.5863 9.1719 25.0253 7.40759 25.0253H3.17826C1.42646 25.0253 0 23.5863 0 21.822V17.5564C0 15.7795 1.42646 14.3518 3.17826 14.3518H7.40759ZM21.8475 14.3518C23.5993 14.3518 25.0258 15.7795 25.0258 17.5564V21.822C25.0258 23.5863 23.5993 25.0253 21.8475 25.0253H17.6182C15.8539 25.0253 14.4399 23.5863 14.4399 21.822V17.5564C14.4399 15.7795 15.8539 14.3518 17.6182 14.3518H21.8475ZM7.40759 0C9.1719 0 10.5858 1.43897 10.5858 3.20453V7.47015C10.5858 9.24697 9.1719 10.6734 7.40759 10.6734H3.17826C1.42646 10.6734 0 9.24697 0 7.47015V3.20453C0 1.43897 1.42646 0 3.17826 0H7.40759ZM21.8475 0C23.5993 0 25.0258 1.43897 25.0258 3.20453V7.47015C25.0258 9.24697 23.5993 10.6734 21.8475 10.6734H17.6182C15.8539 10.6734 14.4399 9.24697 14.4399 7.47015V3.20453C14.4399 1.43897 15.8539 0 17.6182 0H21.8475Z"
          />
        </g>
      </g>
    </svg>
  ),
  routes: () => (
    <svg className="w-full h-full" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="mdi:arrow-decision-outline">
        <path
          id="Vector"
          d="M9.64 13.4C8.63 12.5 7.34 12.03 6 12V15L2 11L6 7V10C7.67 10 9.3 10.57 10.63 11.59C10.223 12.1479 9.89019 12.7563 9.64 13.4ZM18 15V12C17.5 12 13.5 12.16 13.05 16.2C14.61 16.75 15.43 18.47 14.88 20.03C14.6138 20.7798 14.0611 21.3935 13.3432 21.7365C12.6253 22.0796 11.8006 22.124 11.05 21.86C9.5 21.3 8.67 19.59 9.22 18.03C9.5 17.17 10.2 16.5 11.05 16.2C11.1899 14.4715 11.9898 12.8632 13.2839 11.7088C14.578 10.5543 16.2668 9.94244 18 10V7L22 11L18 15ZM13 19C13 18.7348 12.8946 18.4804 12.7071 18.2929C12.5196 18.1054 12.2652 18 12 18C11.7348 18 11.4804 18.1054 11.2929 18.2929C11.1054 18.4804 11 18.7348 11 19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19ZM11 11.12C11.58 10.46 12.25 9.89 13 9.43V5H16L12 1L8 5H11V11.12Z"
        />
      </g>
    </svg>
  ),
  steps: () => (
    <svg className="w-full h-full" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="la:list-ol">
        <path
          id="Vector"
          d="M5.969 3L5.656 3.344C5.656 3.344 4.898 4 4.406 4V6C5.086 6 5.555 5.723 6 5.469V10H8V3H5.969ZM11 6V8H28V6H11ZM6.5 12C6.17159 11.9996 5.84632 12.064 5.54283 12.1895C5.23933 12.315 4.96358 12.4991 4.73135 12.7314C4.49913 12.9636 4.315 13.2393 4.1895 13.5428C4.064 13.8463 3.99961 14.1716 4 14.5V15H6V14.5C6 14.285 6.285 14 6.5 14C6.715 14 7 14.285 7 14.5L6.906 14.594L4.313 17.094L4 17.375V19H9V17H7.281L8.156 16.125L8.281 16.031L8.25 16C8.75 15.59 9 14.98 9 14.5C9 13.117 7.883 12 6.5 12ZM11 15V17H28V15H11ZM4 21V23H5.375L5.125 23.406L5 23.625V25H6.5C6.715 25 7 25.285 7 25.5C7 25.715 6.715 26 6.5 26H4V28H6.5C7.883 28 9 26.883 9 25.5C9 24.496 8.32 23.805 7.469 23.406L7.875 22.719L8 22.469V21H4ZM11 24V26H28V24H11Z"
        />
      </g>
    </svg>
  ),
  userDocs: () => (
    <svg className="h-full w-full" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="material-symbols:clinical-notes">
        <path
          id="Vector"
          d="M17 16C16.1667 16 15.4583 15.7083 14.875 15.125C14.2917 14.5417 14 13.8333 14 13C14 12.1667 14.2917 11.4583 14.875 10.875C15.4583 10.2917 16.1667 10 17 10C17.8333 10 18.5417 10.2917 19.125 10.875C19.7083 11.4583 20 12.1667 20 13C20 13.8333 19.7083 14.5417 19.125 15.125C18.5417 15.7083 17.8333 16 17 16ZM11 23V20.1C11 19.75 11.0833 19.4207 11.25 19.112C11.4167 18.8033 11.65 18.5577 11.95 18.375C12.4833 18.0583 13.046 17.7957 13.638 17.587C14.23 17.3783 14.834 17.2243 15.45 17.125L17 19L18.55 17.125C19.1667 17.225 19.7667 17.3793 20.35 17.588C20.9333 17.7967 21.4917 18.059 22.025 18.375C22.325 18.5583 22.5627 18.8043 22.738 19.113C22.9133 19.4217 23.0007 19.7507 23 20.1V23H11ZM9 20.1V21H5C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V10C20.4833 9.35 19.9 8.854 19.25 8.512C18.6 8.17 17.85 7.99934 17 8V7H7V9H14C13.6667 9.26667 13.3667 9.56667 13.1 9.9C12.8333 10.2333 12.6083 10.6 12.425 11H7V13H12C12 13.35 12.0377 13.6917 12.113 14.025C12.1883 14.3583 12.2923 14.6833 12.425 15H7V17H10.45C10 17.3833 9.64567 17.846 9.387 18.388C9.12834 18.93 8.99934 19.5007 9 20.1Z"
        />
      </g>
    </svg>
  ),
  list: () => (
    <svg className="h-full w-full" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="la:list-ol">
        <path
          id="Vector"
          d="M5.969 3L5.656 3.344C5.656 3.344 4.898 4 4.406 4V6C5.086 6 5.555 5.723 6 5.469V10H8V3H5.969ZM11 6V8H28V6H11ZM6.5 12C6.17159 11.9996 5.84632 12.064 5.54283 12.1895C5.23933 12.315 4.96358 12.4991 4.73135 12.7314C4.49913 12.9636 4.315 13.2393 4.1895 13.5428C4.064 13.8463 3.99961 14.1716 4 14.5V15H6V14.5C6 14.285 6.285 14 6.5 14C6.715 14 7 14.285 7 14.5L6.906 14.594L4.313 17.094L4 17.375V19H9V17H7.281L8.156 16.125L8.281 16.031L8.25 16C8.75 15.59 9 14.98 9 14.5C9 13.117 7.883 12 6.5 12ZM11 15V17H28V15H11ZM4 21V23H5.375L5.125 23.406L5 23.625V25H6.5C6.715 25 7 25.285 7 25.5C7 25.715 6.715 26 6.5 26H4V28H6.5C7.883 28 9 26.883 9 25.5C9 24.496 8.32 23.805 7.469 23.406L7.875 22.719L8 22.469V21H4ZM11 24V26H28V24H11Z"
        />
      </g>
    </svg>
  ),
  docs: () => (
    <svg className="h-full w-full" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="pixelarticons:notes-multiple">
        <path
          id="Vector"
          d="M7 0H23V20H5V0H7ZM21 18V2H7V18H21ZM9 4H19V6H9V4ZM19 8H9V10H19V8ZM9 12H16V14H9V12ZM19 22H3V4H1V24H19V22Z"
        />
      </g>
    </svg>
  ),
  users: () => (
    <svg className="h-full w-full" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="3 User">
        <g id="Iconly/Bold/3-User">
          <g id="3-User">
            <path
              id="3-Friends"
              d="M14.8929 18.0527C19.078 18.0527 22.6515 18.7162 22.6515 21.3712C22.6515 24.0252 19.1009 24.7129 14.8929 24.7129C10.7078 24.7129 7.13429 24.0494 7.13429 21.3954C7.13429 18.7404 10.6849 18.0527 14.8929 18.0527ZM21.5844 16.4539C23.1844 16.4243 24.9045 16.644 25.5401 16.8C26.8867 17.0647 27.7725 17.6052 28.1394 18.3906C28.4496 19.0354 28.4496 19.7835 28.1394 20.4272C27.5781 21.6454 25.7684 22.0365 25.065 22.1376C24.9198 22.1595 24.8029 22.0332 24.8182 21.8871C25.1775 18.5114 22.3194 16.9109 21.58 16.5429C21.5483 16.5265 21.5418 16.5012 21.545 16.4858C21.5472 16.4748 21.5603 16.4572 21.5844 16.4539ZM8.0253 16.4517L8.32659 16.4544C8.35062 16.4577 8.36263 16.4753 8.36481 16.4851C8.36809 16.5016 8.36154 16.5258 8.33096 16.5434C7.59048 16.9114 4.73234 18.5119 5.09165 21.8864C5.10694 22.0336 4.99118 22.1589 4.84592 22.138C4.14258 22.0369 2.33289 21.6459 1.77153 20.4276C1.46027 19.7828 1.46027 19.0358 1.77153 18.391C2.13849 17.6056 3.02313 17.0652 4.36975 16.7993C5.00647 16.6444 6.7255 16.4247 8.32659 16.4544L8.0253 16.4517ZM14.8929 5.19725C17.7423 5.19725 20.0271 7.4931 20.0271 10.3602C20.0271 13.2261 17.7423 15.5242 14.8929 15.5242C12.0435 15.5242 9.75872 13.2261 9.75872 10.3602C9.75872 7.4931 12.0435 5.19725 14.8929 5.19725ZM21.8629 6.05825C24.6151 6.05825 26.7764 8.66278 26.0403 11.5639C25.5434 13.517 23.7446 14.8143 21.7405 14.7616C21.5396 14.7561 21.3419 14.7374 21.1508 14.7045C21.0121 14.6803 20.9422 14.5232 21.0208 14.4068C21.7853 13.2754 22.2211 11.9143 22.2211 10.4533C22.2211 8.92861 21.7449 7.50716 20.9182 6.34166C20.8919 6.30541 20.8723 6.24939 20.8985 6.20765C20.9203 6.17359 20.9607 6.15602 20.999 6.14723C21.2775 6.09011 21.5636 6.05825 21.8629 6.05825ZM8.04645 6.05814C8.3457 6.05814 8.63184 6.09 8.91143 6.14712C8.94857 6.15591 8.99007 6.17458 9.01191 6.20754C9.03703 6.24928 9.01846 6.3053 8.99225 6.34155C8.1655 7.50706 7.68932 8.9285 7.68932 10.4532C7.68932 11.9142 8.12509 13.2752 8.88959 14.4067C8.96822 14.5231 8.89833 14.6802 8.75962 14.7044C8.56741 14.7384 8.37082 14.756 8.16987 14.7615C6.16578 14.8142 4.36702 13.5169 3.87009 11.5638C3.13289 8.66267 5.29425 6.05814 8.04645 6.05814Z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  userPlus: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
      <path d="M6.25 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM3.25 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM19.75 7.5a.75.75 0 00-1.5 0v2.25H16a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0v-2.25H22a.75.75 0 000-1.5h-2.25V7.5z" />
    </svg>
  ),
  userFilled: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-full">
      <path
        fillRule="evenodd"
        d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5.5-2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM10 12a5.99 5.99 0 0 0-4.793 2.39A6.483 6.483 0 0 0 10 16.5a6.483 6.483 0 0 0 4.793-2.11A5.99 5.99 0 0 0 10 12Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  shield: () => (
    <svg className="h-full w-full" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="ic:baseline-privacy-tip">
        <path
          id="Vector"
          d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"
        />
      </g>
    </svg>
  ),
  arrowCircleLeft: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <g clipPath="url(#clip0_9_2121)">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.25-7.25a.75.75 0 000-1.5H8.66l2.1-1.95a.75.75 0 10-1.02-1.1l-3.5 3.25a.75.75 0 000 1.1l3.5 3.25a.75.75 0 001.02-1.1l-2.1-1.95h4.59z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_2121">
          <path d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  arrowCircleRight: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM6.75 9.25a.75.75 0 000 1.5h4.59l-2.1 1.95a.75.75 0 001.02 1.1l3.5-3.25a.75.75 0 000-1.1l-3.5-3.25a.75.75 0 10-1.02 1.1l2.1 1.95H6.75z"
        clipRule="evenodd"
      />
    </svg>
  ),
  arrowDoubleRight: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
    </svg>
  ),
  arrowDoubleLeft: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M15.79 14.77a.75.75 0 01-1.06.02l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 111.04 1.08L11.832 10l3.938 3.71a.75.75 0 01.02 1.06zm-6 0a.75.75 0 01-1.06.02l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 111.04 1.08L5.832 10l3.938 3.71a.75.75 0 01.02 1.06z"
        clipRule="evenodd"
      />
    </svg>
  ),
  arrowLongUp: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M10 18a.75.75 0 01-.75-.75V4.66L7.3 6.76a.75.75 0 11-1.1-1.02l3.25-3.5a.75.75 0 011.1 0l3.25 3.5a.75.75 0 01-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0110 18z"
        clipRule="evenodd"
      />
    </svg>
  ),
  arrowLongDown: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
        clipRule="evenodd"
      />
    </svg>
  ),
  arrowSmallUp: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M10 15a.75.75 0 01-.75-.75V7.612L7.29 9.77a.75.75 0 01-1.08-1.04l3.25-3.5a.75.75 0 011.08 0l3.25 3.5a.75.75 0 11-1.08 1.04l-1.96-2.158v6.638A.75.75 0 0110 15z"
        clipRule="evenodd"
      />
    </svg>
  ),
  arrowSmallDown: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M10 5a.75.75 0 01.75.75v6.638l1.96-2.158a.75.75 0 111.08 1.04l-3.25 3.5a.75.75 0 01-1.08 0l-3.25-3.5a.75.75 0 111.08-1.04l1.96 2.158V5.75A.75.75 0 0110 5z"
        clipRule="evenodd"
      />
    </svg>
  ),
  alertTriangle: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      />
    </svg>
  ),
  alertTriangleFilled: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
        clipRule="evenodd"
      />
    </svg>
  ),
  check: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
    </svg>
  ),
  checkCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-full">
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
        clipRule="evenodd"
      />
    </svg>
  ),
  chevronUp: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M14.77 12.79a.75.75 0 01-1.06-.02L10 8.832 6.29 12.77a.75.75 0 11-1.08-1.04l4.25-4.5a.75.75 0 011.08 0l4.25 4.5a.75.75 0 01-.02 1.06z"
        clipRule="evenodd"
      />
    </svg>
  ),
  chevronDown: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
        clipRule="evenodd"
      />
    </svg>
  ),
  plusFolder: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
      />
    </svg>
  ),
  plus: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>
  ),
  plusCircle: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  info: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
      />
    </svg>
  ),
  infoFilled: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-full">
      <path
        fillRule="evenodd"
        d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  closeCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
        clipRule="evenodd"
      />
    </svg>
  ),
  close: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  closeMini: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
    </svg>
  ),
  trash: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
      />
    </svg>
  ),
  spinner: () => (
    <svg className="animate-spin h-full w-full" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
      <path
        className="opacity-50"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  ),
  menu: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  ),
  download: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path d="M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z" />
      <path d="M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z" />
    </svg>
  ),
  starFilled: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
        clipRule="evenodd"
      />
    </svg>
  ),
  clock: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  clockFilled: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  save: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path d="M10 2a.75.75 0 01.75.75v5.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0L6.2 7.26a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z" />
      <path d="M5.273 4.5a1.25 1.25 0 00-1.205.918l-1.523 5.52c-.006.02-.01.041-.015.062H6a1 1 0 01.894.553l.448.894a1 1 0 00.894.553h3.438a1 1 0 00.86-.49l.606-1.02A1 1 0 0114 11h3.47a1.318 1.318 0 00-.015-.062l-1.523-5.52a1.25 1.25 0 00-1.205-.918h-.977a.75.75 0 010-1.5h.977a2.75 2.75 0 012.651 2.019l1.523 5.52c.066.239.099.485.099.732V15a2 2 0 01-2 2H3a2 2 0 01-2-2v-3.73c0-.246.033-.492.099-.73l1.523-5.521A2.75 2.75 0 015.273 3h.977a.75.75 0 010 1.5h-.977z" />
    </svg>
  ),
  cog: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path d="M13.024 9.25c.47 0 .827-.433.637-.863a4 4 0 00-4.094-2.364c-.468.05-.665.576-.43.984l1.08 1.868a.75.75 0 00.649.375h2.158zM7.84 7.758c-.236-.408-.79-.5-1.068-.12A3.982 3.982 0 006 10c0 .884.287 1.7.772 2.363.278.38.832.287 1.068-.12l1.078-1.868a.75.75 0 000-.75L7.839 7.758zM9.138 12.993c-.235.408-.039.934.43.984a4 4 0 004.094-2.364c.19-.43-.168-.863-.638-.863h-2.158a.75.75 0 00-.65.375l-1.078 1.868z" />
      <path
        fillRule="evenodd"
        d="M14.13 4.347l.644-1.117a.75.75 0 00-1.299-.75l-.644 1.116a6.954 6.954 0 00-2.081-.556V1.75a.75.75 0 00-1.5 0v1.29a6.954 6.954 0 00-2.081.556L6.525 2.48a.75.75 0 10-1.3.75l.645 1.117A7.04 7.04 0 004.347 5.87L3.23 5.225a.75.75 0 10-.75 1.3l1.116.644A6.954 6.954 0 003.04 9.25H1.75a.75.75 0 000 1.5h1.29c.078.733.27 1.433.556 2.081l-1.116.645a.75.75 0 10.75 1.298l1.117-.644a7.04 7.04 0 001.523 1.523l-.645 1.117a.75.75 0 101.3.75l.644-1.116a6.954 6.954 0 002.081.556v1.29a.75.75 0 001.5 0v-1.29a6.954 6.954 0 002.081-.556l.645 1.116a.75.75 0 001.299-.75l-.645-1.117a7.042 7.042 0 001.523-1.523l1.117.644a.75.75 0 00.75-1.298l-1.116-.645a6.954 6.954 0 00.556-2.081h1.29a.75.75 0 000-1.5h-1.29a6.954 6.954 0 00-.556-2.081l1.116-.644a.75.75 0 00-.75-1.3l-1.117.645a7.04 7.04 0 00-1.524-1.523zM10 4.5a5.475 5.475 0 00-2.781.754A5.527 5.527 0 005.22 7.277 5.475 5.475 0 004.5 10a5.475 5.475 0 00.752 2.777 5.527 5.527 0 002.028 2.004c.802.458 1.73.719 2.72.719a5.474 5.474 0 002.78-.753 5.527 5.527 0 002.001-2.027c.458-.802.719-1.73.719-2.72a5.475 5.475 0 00-.753-2.78 5.528 5.528 0 00-2.028-2.002A5.475 5.475 0 0010 4.5z"
        clipRule="evenodd"
      />
    </svg>
  ),
  linkOut: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M4.25 5.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0112.75 17h-8.5A2.25 2.25 0 012 14.75v-8.5A2.25 2.25 0 014.25 4h5a.75.75 0 010 1.5h-5z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M6.194 12.753a.75.75 0 001.06.053L16.5 4.44v2.81a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.553l-9.056 8.194a.75.75 0 00-.053 1.06z"
        clipRule="evenodd"
      />
    </svg>
  ),
  sparkles: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813A3.75 3.75 0 007.466 7.89l.813-2.846A.75.75 0 019 4.5zM18 1.5a.75.75 0 01.728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 010 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 01-1.456 0l-.258-1.036a2.625 2.625 0 00-1.91-1.91l-1.036-.258a.75.75 0 010-1.456l1.036-.258a2.625 2.625 0 001.91-1.91l.258-1.036A.75.75 0 0118 1.5zM16.5 15a.75.75 0 01.712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 010 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 01-1.422 0l-.395-1.183a1.5 1.5 0 00-.948-.948l-1.183-.395a.75.75 0 010-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0116.5 15z"
        clipRule="evenodd"
      />
    </svg>
  ),
  dotsHorizontal: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
        clipRule="evenodd"
      />
    </svg>
  ),
  refresh: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
      />
    </svg>
  ),
  tag: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M5.5 3A2.5 2.5 0 003 5.5v2.879a2.5 2.5 0 00.732 1.767l6.5 6.5a2.5 2.5 0 003.536 0l2.878-2.878a2.5 2.5 0 000-3.536l-6.5-6.5A2.5 2.5 0 008.38 3H5.5zM6 7a1 1 0 100-2 1 1 0 000 2z"
        clipRule="evenodd"
      />
    </svg>
  ),
  filter: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-full h-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
      />
    </svg>
  ),
  clipboard: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-full h-full">
      <path
        fillRule="evenodd"
        d="M13.887 3.182c.396.037.79.08 1.183.128C16.194 3.45 17 4.414 17 5.517V16.75A2.25 2.25 0 0114.75 19h-9.5A2.25 2.25 0 013 16.75V5.517c0-1.103.806-2.068 1.93-2.207.393-.048.787-.09 1.183-.128A3.001 3.001 0 019 1h2c1.373 0 2.531.923 2.887 2.182zM7.5 4A1.5 1.5 0 019 2.5h2A1.5 1.5 0 0112.5 4v.5h-5V4z"
        clipRule="evenodd"
      />
    </svg>
  ),
  userCircle2Tone: ({ primary, secondary }: IconSvgProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-full h-full">
      <circle cx={12} cy={12} r={10} className={primary} fill="currentColor" />
      <path
        fill="currentColor"
        className={secondary}
        d="M3.66 17.52A5 5 0 0 1 8 15h8a5 5 0 0 1 4.34 2.52 10 10 0 0 1-16.68 0zM12 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
      />
    </svg>
  ),
  logout2Tone: ({ primary, secondary }: IconSvgProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-full h-full">
      <path
        fill="currentColor"
        className={primary}
        d="M11 4h3a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V6h-2v12h2v-2a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3v1a1 1 0 0 1-1.27.96l-6.98-2A1 1 0 0 1 2 19V5a1 1 0 0 1 .75-.97l6.98-2A1 1 0 0 1 11 3v1z"
      />
      <path
        fill="currentColor"
        className={secondary}
        d="M18.59 11l-1.3-1.3c-.94-.94.47-2.35 1.42-1.4l3 3a1 1 0 0 1 0 1.4l-3 3c-.95.95-2.36-.46-1.42-1.4l1.3-1.3H14a1 1 0 0 1 0-2h4.59z"
      />
    </svg>
  ),
  login2Tone: ({ primary, secondary }: IconSvgProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-full h-full">
      <path
        fill="currentColor"
        className={primary}
        d="M13 4V3a1 1 0 0 1 1.27-.96l6.98 2A1 1 0 0 1 22 5v14a1 1 0 0 1-.75.97l-6.98 2A1 1 0 0 1 13 21v-1h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v1h2V6h-2v1a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1h3z"
      />
      <path
        fill="currentColor"
        className={secondary}
        d="M7.59 11l-1.3-1.3c-.94-.94.47-2.35 1.42-1.4l3 3a1 1 0 0 1 0 1.4l-3 3c-.95.95-2.36-.46-1.42-1.4L7.6 13H3a1 1 0 0 1 0-2h4.59z"
      />
    </svg>
  ),
  help2Tone: ({ primary, secondary }: IconSvgProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-full h-full">
      <path fill="currentColor" className={primary} d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z" />
      <path
        fill="currentColor"
        className={secondary}
        d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
      />
    </svg>
  ),
  shield2Tone: ({ primary, secondary }: IconSvgProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-full h-full">
      <path
        fill="currentColor"
        className={primary}
        d="M4 4l8-2 8 2v9.06a8 8 0 0 1-4.42 7.15L12 22l-3.58-1.79A8 8 0 0 1 4 13.06V4z"
      />
      <path
        fill="currentColor"
        className={secondary}
        d="M6 12V5.56l6-1.5V12H6zm6 7.76V12h6v1.06a6 6 0 0 1-3.32 5.36L12 19.76z"
      />
    </svg>
  ),
  arrowLongRight: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
    </svg>
  ),
  arrowRight: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
  ),
  lock: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
      />
    </svg>
  ),
  chevronLeft: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
    </svg>
  ),
  chevronRight: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
    </svg>
  ),
  chevronUpDown: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
    </svg>
  ),
  calendar: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
      />
    </svg>
  ),
  location: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
      />
    </svg>
  ),
  arrowLeft: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="full-size"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
    </svg>
  ),
  pencil: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
      />
    </svg>
  ),
  click: ({ strokeWidth }: IconSvgProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      className="size-full"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
      />
    </svg>
  ),
};

type IconSvgProps = {
  primary?: string;
  secondary?: string;
  strokeWidth?: number;
};

interface IconProps {
  name: keyof typeof iconDefs;
  className?: string;
  as?: "div" | "span";
  title?: string;
  primary?: string;
  secondary?: string;
  strokeWidth?: number;
}

export default function Icon({ as = "span", name, className = "", title, primary, secondary, strokeWidth }: IconProps) {
  const IconComponent = iconDefs[name]({
    primary,
    secondary,
    strokeWidth: strokeWidth || 1.5,
  });

  return createElement(
    as,
    {
      className: twMerge("size-5", as === "span" ? "inline-block" : "", className),
      title,
    },
    IconComponent
  );
}
